import React, { useState } from "react";
import MiniTiptapEditor from "../../../component/MiniTiptapEditor";
import LevelBadge from "../../../global/LevelBadge";

type Comment = {
	id: number;
	authorNickname?: string;
	content: string;
	createdAt: string;
	userId?: number;
	authorLevel: number;
};

type CommentItemProps = {
	comment: Comment;
	currentUserId?: number;
	onUpdate: (id: number, newContent: string) => void | Promise<void | boolean>;
	onDelete: (id: number) => void | Promise<void | boolean>;
};

function CommentItem({ comment, currentUserId, onUpdate, onDelete }: CommentItemProps) {
	const isAuthor = currentUserId === comment.userId;
	const [isEditing, setIsEditing] = useState(false);
	const [editContent, setEditContent] = useState(comment.content);

	const [saving, setSaving] = useState(false);
    const handleSave = async () => {
        if (saving) return;
        setSaving(true);
        try {
            const result = await onUpdate(comment.id, editContent);
            if (result !== false) setIsEditing(false);
        } catch {
            // Preserve the draft when the caller's request fails.
        } finally { setSaving(false); }
    };

	return (
		<div className="CommentItem">
			{/* ✅ 헤더 추가 (레벨 + 닉네임 가로 정렬) */}
			<div className="CommentHeader">
				<LevelBadge level={comment.authorLevel} />
				<span className="CommentAuthor">{comment.authorNickname}</span>
			</div>

			<div className="CommentContent">
				{isEditing ? (
					<>
						<MiniTiptapEditor content={editContent} onChange={setEditContent} />
						<div className="CommentActions">
							<button disabled={saving} onClick={handleSave}>저장</button>
							<button disabled={saving} onClick={() => setIsEditing(false)}>취소</button>
						</div>
					</>
				) : (
					<div dangerouslySetInnerHTML={{ __html: comment.content }} />
				)}
			</div>

			<div className="CommentDate">
				{new Date(comment.createdAt).toLocaleString()}
			</div>

			{isAuthor && !isEditing && (
				<div className="CommentActions">
					<button onClick={() => { setEditContent(comment.content); setIsEditing(true); }}>수정</button>
					<button onClick={() => onDelete(comment.id)}>삭제</button>
				</div>
			)}
		</div>
	);
}

export default CommentItem;
